import React from "react";
import { US_STATES } from "../QuizForm";
import { isValidEmail, isValidZip } from "../publicFormValidators";
import { formatUSPhone, isValidUSPhone } from "../publicFormPhone";

export const CF_INPUT = "cf-input h-12 w-full rounded-lg border border-white/15 bg-white/[0.06] px-3.5 text-base text-white placeholder:text-slate-500 transition-colors duration-200 focus:border-[var(--cf-accent)] focus:outline-none";

const Field = ({ label, error, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">{label}</span>
    {children}
    {error && <span className="mt-1 block text-xs text-red-300">{error}</span>}
  </label>
);

export const ContactStep = ({ a, set, zipOptional = false }) => {
  const input = (field, extra = {}) => (
    <input
      className={CF_INPUT}
      name={field}
      value={a[field]}
      onChange={(e) => set(field, extra.format ? extra.format(e.target.value) : e.target.value)}
      type={extra.type || "text"}
      inputMode={extra.inputMode}
      autoComplete={extra.autoComplete}
      placeholder={extra.placeholder}
      maxLength={extra.maxLength}
      data-testid={`case-quiz-${field.replace("_", "-")}`}
    />
  );
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-testid="case-quiz-contact">
      <Field label="First name">{input("first_name", { autoComplete: "given-name" })}</Field>
      <Field label="Last name">{input("last_name", { autoComplete: "family-name" })}</Field>
      <Field label="Mobile phone" error={a.phone && !isValidUSPhone(a.phone) ? "Enter a 10-digit US number" : ""}>
        {input("phone", { type: "tel", inputMode: "tel", autoComplete: "tel", placeholder: "555-555-0100", format: formatUSPhone })}
      </Field>
      <Field label="Email" error={a.email && !isValidEmail(a.email) ? "Enter a valid email" : ""}>
        {input("email", { type: "email", autoComplete: "email", placeholder: "you@email.com" })}
      </Field>
      <Field label="State">
        <select className={`${CF_INPUT} cf-select`} name="state" autoComplete="address-level1" value={a.state} onChange={(e) => set("state", e.target.value)} data-testid="case-quiz-state">
          <option value="">Choose…</option>
          {US_STATES.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
        </select>
      </Field>
      <Field label={zipOptional ? "ZIP (optional)" : "ZIP"} error={a.zip && !isValidZip(a.zip) ? "Enter a 5-digit ZIP" : ""}>
        {input("zip", { inputMode: "numeric", autoComplete: "postal-code", maxLength: 10 })}
      </Field>
    </div>
  );
};
